import { NgModule } from '@angular/core';
import {ADD_TO_WISHLIST_FEATURE, CART_WISH_LIST_FEATURE, WishListRootModule} from '@spartacus/cart/wish-list/root';
import { I18nConfig, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [
    WishListRootModule
  ],
  providers: [
    provideConfig({
      featureModules: {
        [CART_WISH_LIST_FEATURE]: {
          module: () =>
              import('../../../components/uig-wish-list/uig-wish-list.module').then((m) => m.UigWishListModule),
        },
        [ADD_TO_WISHLIST_FEATURE]: {
          module: () =>
              import('@spartacus/cart/wish-list/components/add-to-wishlist').then(
                  (m) => m.AddToWishListModule
              ),
        },
      },
    }),
    provideConfig({
      i18n: {
        chunks: { uigWishList: ['uigWishList'] },
      },
    } as I18nConfig),
  ],
})
export class WishListFeatureModule { }
